import { FC } from 'react';
import { CmsImage } from '@zoopla/cms/image';
import { FigureWrapper, FigCaption } from './ImageWrapperEntry.styles';

export type Props = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    nodeData: Record<string, any>;
};

const ImageWrapperEntry: FC<React.PropsWithChildren<Props>> = ({
    nodeData
}) => {
    const { caption, altText } = nodeData?.data?.target?.fields || {};

    return (
        <FigureWrapper>
            <CmsImage
                data-testid={`image-${nodeData?.data?.target?.sys.id}`}
                src={nodeData?.data.target.fields.image.fields.file.url}
                width={1500}
                alt={caption === altText ? '' : altText}
                loading="lazy"
            />
            {caption && (
                <FigCaption size="secondary">Image: {caption}</FigCaption>
            )}
        </FigureWrapper>
    );
};

export default ImageWrapperEntry;
